import { styled, Typography } from "@mui/material";
import { Checkbox } from "@volt_developers/components";

import { TEST_IDS } from "constants/TestIds";

import type { ReactNode, SyntheticEvent } from "react";

import type { CountryCode } from "models/CountryCode";

export interface CountryLabelProps {
  id: CountryCode;
  isSelected: boolean;
  label: ReactNode;
  onChange: (event: SyntheticEvent) => void;
}

export function CountryLabel({
  id,
  label,
  isSelected,
  onChange,
}: CountryLabelProps) {
  const testId = TEST_IDS.getCheckbox(id);

  return (
    <Wrapper>
      <Checkbox
        checked={isSelected}
        data-testid={testId}
        id={testId}
        onChange={onChange}
        onClick={(event) => event.stopPropagation()}
      />
      <Typography color="text.high" variant="small">
        {label}
      </Typography>
    </Wrapper>
  );
}

const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1.5),
}));
